import StorefrontIcon from "@mui/icons-material/Storefront";
import { Stack, Typography } from "@mui/material";
import { AssignHunterForm } from "Components/Admin/UnassignedMerchants/AssignHunterForm";
import { ModalDialog } from "Components/Shared/Dialogs/ModalDialog";
import type { UnassignedMerchantListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.UnassignedMerchants.AssignDialog;

type Props = {
  merchant: UnassignedMerchantListItemDto | null;
  isOpen: boolean;
  onClose: () => void;
};

export const AssignHunterDialog = ({ merchant, isOpen, onClose }: Props) => {
  const { t } = useResource();

  if (!merchant) {
    return null;
  }

  return (
    <ModalDialog title={t(RESOURCES.Title)} isOpen={isOpen} onClose={onClose}>
      <Stack direction="row" alignItems="center" gap={1}>
        <StorefrontIcon />
        <Typography variant="h6">
          {t(RESOURCES.Subtitle, {
            companyName: merchant.party?.companyName ?? "",
            companyNumber: merchant.party?.companyNumber ?? "",
          })}
        </Typography>
      </Stack>
      <AssignHunterForm merchant={merchant} onClose={onClose} />
    </ModalDialog>
  );
};
